import { Moment } from 'moment'
import { getUserTransactionsSelector } from '@/features/transactions/transactions.selectors'
import { MobileTableRow } from '@/features/transactions/transaction-table/MobileTableRow'
import { Card, Separator, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'

export const ReportsTransactionTable = ({
  startDate,
  endDate,
  formattedMonth,
}: {
  startDate: Moment
  endDate: Moment
  formattedMonth: string
}) => {
  const transactions = useReselector(getUserTransactionsSelector, {
    startDate,
    endDate,
  })

  return (
    <Card>
      <Text variant={TypographyStyles.H1} className="mt-6">
        {formattedMonth} Transactions
      </Text>
      <Separator className="mt-2 mb-6" />
      <div className="flex flex-col sm:flex-row w-full pb-2">
        <Text className="sm:w-2/12 w-full" variant={TypographyStyles.EYEBROW}>
          Date
        </Text>
        <Text className="sm:w-2/12 w-full" variant={TypographyStyles.EYEBROW}>
          Amount
        </Text>
        <Text className="sm:w-4/12 w-full" variant={TypographyStyles.EYEBROW}>
          Description
        </Text>
        <Text className="sm:w-4/12 w-full" variant={TypographyStyles.EYEBROW}>
          Transaction Category
        </Text>
      </div>

      <div className="space-y-2 mt-2">
        {transactions.length > 0 ? (
          transactions.map((transaction) => (
            <MobileTableRow
              key={transaction.id}
              transaction={transaction}
              reports
            />
          ))
        ) : (
          <Text variant={TypographyStyles.BODY_SM} className="text-center my-4">
            No transactions this month!
          </Text>
        )}
      </div>
    </Card>
  )
}
